import React, { useState, useEffect } from "react";
import { Header } from "../components/Header.js";
import { Footer } from "../components/Footer.js";
import { Slide_title } from "../components/slide-title.js";

import { Account_head } from "../components/account_head.js";
import { basic_info } from "../service/api.js";
import ErrorSnackbar from "../components/ErrorSnackbar.js";
import SuccessSnackbar from "../components/SuccessSnackbar.js";
import { useNavigate } from "react-router-dom";
import Head_CateHead from "../components/Head_CateHead.js";

import { Acc_change_pass } from "./acc_change_pass.js"
import { Acc_address } from "./acc_address.js";

export const Account = () => {
  const navigate = useNavigate();

  const [ExceptionError, setExceptionError] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);

  function handleExceptionError(res) {
    setExceptionError((ExceptionError) => [
      ...ExceptionError,
      { id: Date.now(), message: res },
    ]);
  }

  function handleExceptionSuccessMessages(res) {
    setSuccessMessages((successMessages) => [
      ...successMessages,
      { id: Date.now(), message: res.data.Message },
    ]);
  }

  function clearErrors(id) {
    setExceptionError((prevMessages) =>
      prevMessages.filter((msg) => msg.id !== id)
    );
  }
  function clearSuccess(id) {
    setSuccessMessages((prevMessages) =>
      prevMessages.filter((msg) => msg.id !== id)
    );
  }

  const [data, setData] = useState({
    FullName: "",
    Email: "",
    MobileNumber: "",
  });

  const [validationErrors, setValidationErrors] = useState({
    FullName: "",
    Email: "",
    MobileNumber: "",
  });

  const data_get = async () => {
    try {
      setData({
        FullName: localStorage.getItem("FullName") ?? "",
        Email: localStorage.getItem("Email") ?? "",
        MobileNumber: localStorage.getItem("MobileNumber") ?? "",
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      data_get();
    } else {
      navigate("/signin");
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = {};
    if (!data.FullName.trim()) {
      errors.FullName = "Fullname is required.";
    }
    if (!data.Email.trim()) {
      errors.Email = "Email is required.";
    }
    if (data.Email) {
      const email_pattern = /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
      if (!email_pattern.test(data.Email)) {
        errors.Email = "Invalid Email format";
      }
    }
    if (!data.MobileNumber.trim()) {
      errors.MobileNumber = "Mobile number is required.";
    }
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    setValidationErrors({});

    // Pass existing DOB/Gender/Bio from localStorage so the API payload
    // is not disrupted — we are only removing them from the UI, not the API.
    const res = await basic_info({
      ...data,
      DOB: localStorage.getItem("DOB") ?? "",
      Gender: localStorage.getItem("Gender") ?? "",
      Bio: localStorage.getItem("Bio") ?? "",
    });

    if (res.status === 200) {
      localStorage.setItem("FullName", data.FullName);
      localStorage.setItem("MobileNumber", data.MobileNumber);
      handleExceptionSuccessMessages(res);
    } else {
      handleExceptionError(res.response?.data?.ErrorMessage ?? "An error occurred.");
    }
  };

  return (
    <div>
      <ErrorSnackbar
        errorMessages={ExceptionError}
        onClearErrors={clearErrors}
      />
      <SuccessSnackbar
        successMessages={successMessages}
        onclearSuccess={clearSuccess}
      />
      <Head_CateHead />
      <Account_head title_="Account Information" />
      <div className="account_detail container account">
        <div className="account_detail_right" style={{ width: '100%', maxWidth: '600px' }}>
          <form onSubmit={handleSubmit}>
            <div className="checkout_form_tel account first">
              <h3>Full Name</h3>
              <input
                type="text"
                value={data.FullName}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setData((prevData) => ({ ...prevData, FullName: newValue }));
                  setValidationErrors((prevErrors) => ({
                    ...prevErrors,
                    FullName: "",
                  }));
                }}
              />
              {validationErrors.FullName && (
                <div className="error">{validationErrors.FullName}</div>
              )}
            </div>
            <div className="checkout_form_tel account">
              <h3>Email address</h3>
              <input
                type="email"
                value={data.Email}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setData((prevData) => ({ ...prevData, Email: newValue }));
                  setValidationErrors((prevErrors) => ({
                    ...prevErrors,
                    Email: "",
                  }));
                }}
              />
              {validationErrors.Email && (
                <div className="error">{validationErrors.Email}</div>
              )}
            </div>
            <div className="checkout_form_tel account">
              <h3>Phone number</h3>
              <input
                type="tel"
                value={data.MobileNumber}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setData((prevData) => ({
                    ...prevData,
                    MobileNumber: newValue,
                  }));
                  setValidationErrors((prevErrors) => ({
                    ...prevErrors,
                    MobileNumber: "",
                  }));
                }}
              />
              {validationErrors.MobileNumber && (
                <div className="error">{validationErrors.MobileNumber}</div>
              )}
            </div>
            <button type="submit">Update account</button>
          </form>
        </div>
        <Acc_change_pass />
      </div>
      <Acc_address />
      <Footer />
    </div>
  );
};
